export const partition = async (source, predicate) => {
    const fail = [];
    const pass = [];
    for await (const value of source) {
        if (predicate(value) === true) {
            pass.push(value);
        }
        else {
            fail.push(value);
        }
    }
    return [pass, fail];
};
